import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'data',
    templateUrl: '../../templates/partials/data-bill.html'
})

export class DataBillComponent implements OnInit {

    @Input() data;
    constructor(private router: Router) { }

    public goToService(id: string) {
        this.router.navigate(["/services", id])
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/dummy/data-bill.component.ts